import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Button from "../../common/Button";
import Col from "../../common/Col";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";
import MapView from "../../common/map/MapView";
import Section from "../../common/Section";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import Files from "../../common/Files";
import documentHelperUtil from "../../../components/common/DocumentHelperUtil";
import ANBGebied from "../../../images/map/ANBGebied.png";

const SamenvattingForm = (props) => {
    const {
        disabled,
        color,
        documents,
        isPollingDocument,
        onGeneratePDF,
        stratenlijstFilesProps,
        fileDownloadUrl,
        osmBaseLayerUrl,
        lussen,
        customBounds,
        onSetStyle
    } = props;

    function handleOnGenereerPdf(pdfPollingProps) {
        return function () {
            onGeneratePDF(pdfPollingProps);
        };
    }

    const componentName = "pdf";

    let pdfDocumentenProps =
        documentHelperUtil.getDocumentComponentProps(
            "PDF",
            componentName,
            fileDownloadUrl,
            documents,
            true,
            null,
            null,
            null,
            false,
            null,
            null,
            color,
            6
        );

    const maxPollCount = 10;
    const isPollingDocumentValue = isPollingDocument(pdfDocumentenProps.componentName, maxPollCount);
    const pdfPollingProps = documentHelperUtil.getPollingProps(maxPollCount, 1, isPollingDocumentValue, componentName);

    function style(feature, color) {
        return onSetStyle ? onSetStyle(feature, color) : { color: "#FF0000" };
    }
    const heeftRoutes = !!(lussen && lussen.length && lussen.find(l => l.geoJson));
    const geoJsonLayers = lussen && lussen.length ? lussen.map(x => ({
        id: x.naam,
        data: x.geoJson,
        showDirection: true,
        style: feature => style(feature, x.color)
    })) : [];

    const legendeCustomRows = [
        <Row key="anbGebiedLegende"><img style={{ height: '30px', width: '30px', marginLeft: '-9px' }} src={ANBGebied} />&nbsp;&nbsp;ANB Gebied</Row>,
        ...(lussen && lussen.length ? lussen.map(x => <Row key={"lusLegende" + x.naam}><Col size={2}><div style={{ color: x.color, fontWeight: 'bold' }} >---</div></Col><Col size={10}>&nbsp;<span style={{ color: x.color, fontWeight: 'bold' }}>Afstand {x.naam}</span></Col></Row>) : [])
    ];

    return (
        <Form name="Samenvatting"
            headerVisible={false}
            isNotRequired
            color={color}>
            <Fieldset title={"Alle afstanden van je tocht"}>
                {heeftRoutes ?
                    <Row>
                        <MapView
                            baseLayerUrl={osmBaseLayerUrl}
                            mapName="route"
                            geoJsonLayers={geoJsonLayers}
                            zoom={12}
                            legendeRows={legendeCustomRows}
                            bounds={customBounds}
                        />
                    </Row>
                    :
                    <Section style={{marginBottom:'0px'}}><p>Er werden nog geen routes opgeladen voor deze tocht.</p></Section>
                }
            </Fieldset>
            <Fieldset>
                <Row>
                    <DownloadUploadFiles {...pdfDocumentenProps} />
                    <Col size={6}>
                        <div className="c-fiche-wrap">
                            <div className="">
                                <Button className={"o-col-12"} onClick={handleOnGenereerPdf(pdfPollingProps)} disabled={isPollingDocumentValue || disabled} text={"Genereer PDF"} />
                                {isPollingDocumentValue ?
                                    <div>even geduld a.u.b.</div>
                                    : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Fieldset>
            {heeftRoutes ?
                <Fieldset>
                    <Row>
                        <Files {...stratenlijstFilesProps} />
                    </Row>
                </Fieldset>
                : null}
        </Form>);
};

SamenvattingForm.propTypes = {
    disabled: PropTypes.bool,
    color: PropTypes.string,
    documents: PropTypes.array,
    isPollingDocument: PropTypes.bool,
    onGeneratePDF: PropTypes.func.isRequired,
    stratenlijstFilesProps: PropTypes.object,
    fileDownloadUrl: PropTypes.string.isRequired,
    osmBaseLayerUrl: PropTypes.string,
    lussen: PropTypes.array,
    customBounds: PropTypes.array,
    onSetStyle: PropTypes.func
};

export default SamenvattingForm;